import PropTypes from 'prop-types';
import React from 'react';
import { connect} from 'react-redux';

const NewMessageButton = ({ onClick }) => {
  return (
    <div className="small-12">
      <span className="o-sp-button o-sp-button--update o-sp-button--primary u-float--right"
        onClick={onClick}>
        New Message
      </span>
    </div>
  )
};

NewMessageButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

const mapStateToProps = _state => ({});

export default connect(mapStateToProps, {})(NewMessageButton);
